import React from "react";
import { useSearchParams } from "react-router-dom";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

import { useGetUrlParams } from "hooks";

const SORT_OPTIONS = [
  {
    label: "Created At (Desc)",
    sortBy: "createdAt",
    direction: -1,
  },
  {
    label: "Created At (Asc)",
    sortBy: "createdAt",
    direction: 1,
  },
  {
    label: "Updated At (Desc)",
    sortBy: "updatedAt",
    direction: -1,
  },
  {
    label: "Updated At (Asc)",
    sortBy: "updatedAt",
    direction: 1,
  },
];

const ParamsSortBy = ({ sortOptions = SORT_OPTIONS, ...props }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const URL_PARAMS = useGetUrlParams();

  const sortBy = searchParams.get("sortBy") || "createdAt";
  const sortDirection = searchParams.get("sortDirection") || -1;

  const selectedSortOption = React.useMemo(
    () =>
      sortOptions?.find(
        (el) => el?.sortBy === sortBy && el?.direction === +sortDirection
      ),
    [sortBy, sortDirection, sortOptions]
  );

  return (
    <div className="w-60">
      <FormControl fullWidth size="small" {...props}>
        <InputLabel id="sort-select">Sort By</InputLabel>

        <Select
          labelId="sort-select"
          label="Sort by"
          value={selectedSortOption?.label}
          onChange={(e) => {
            const sortOption = sortOptions?.find(
              (el) => el?.label === e.target.value
            );

            if (!sortOption) return;

            setSearchParams({
              ...URL_PARAMS,
              sortBy: sortOption.sortBy,
              sortDirection: sortOption.direction,
            });
          }}
        >
          {sortOptions?.map((opt) => (
            <MenuItem key={opt?.label} value={opt?.label}>
              {opt?.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default ParamsSortBy;
